import { Modal} from 'antd'
import React from 'react'
import _ from "lodash";
import { useTranslation } from 'react-i18next';

const UretilemeyenListModal = ({
    modalOpenUretilemeyen,
    setModalOpenUretilemeyen,
    modifiedDataUretilemeyen,
}) => {
    const { t } = useTranslation();

    return (
        <div>
            <Modal
                title={t('constraint.unproducibleList')}
                centered
                open={modalOpenUretilemeyen}
                onCancel={() => {
                    setModalOpenUretilemeyen(false)
                }}
                cancelButtonProps={{ style: { display: 'none' } }}
                okButtonProps={{ style: { display: 'none' } }}
            >
                <div className='flex flex-wrap gap-2 text-md font-semibold fo mt-6'>
                    {
                        modifiedDataUretilemeyen.map(item => {
                            return (
                                <div className='bg-smartoptLogoColor p-2 rounded-sm w-[110px]'>
                                    {item.panel_list ? item.panel_list : t('constraint.noUnproducible')}
                                </div>
                            )
                        })
                    }
                </div>
            </Modal>
        </div>
    )
}

export default UretilemeyenListModal